import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const AcimaDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "acima-apply-approved",
    path: "approved",
    component: () => import("./components/AcimaApproved.vue"),
  },
  {
    name: "acima-apply-declined",
    path: "declined",
    component: () => import("./components/AcimaDeclined.vue"),
  },
  {
    name: "acima-apply-pending",
    path: "pending",
    component: () => import("./components/AcimaPending.vue"),
  },
  {
    name: "acima-apply-prequalified",
    path: "prequalified",
    component: () => import("./components/AcimaPrequalified.vue"),
    meta: {
      next: "../application",
      step: (steps) =>
        steps.includes("applicant") ? "applicant" : "reviewOffer",
    },
  },
  {
    name: "acima-apply-error",
    path: "error",
    component: () => import("./components/AcimaError.vue"),
  },
  {
    name: "acima-apply-nooffer",
    path: "nooffer",
    component: () => import("./components/AcimaNoOffer.vue"),
  },
]

export const AcimaApplyRoutes: RouteRecordRaw[] = [
  {
    name: "acima-apply-routes",
    path: "acima_standard",
    children: [
      {
        name: "acima-apply-start",
        path: "start/:mode",
        component: () => import("./pages/AcimaIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "acima-apply-decisions",
        path: "decision",
        component: () => import("./pages/AcimaDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: [...AcimaDecisionRoutes],
      },
      {
        name: "acima-terms",
        path: "terms",
        component: () => import("./pages/AcimaTermsAndConditionsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "acima-quiz",
        path: "quiz",
        children: [
          {
            name: "acima-identity-quiz",
            path: "identity_quiz",
            component: () => import("./pages/AcimaIdentityQuizPage.vue"),
            props: {
              id: "identity_quiz",
            },
          },
          {
            name: "acima-bank-account-quiz",
            path: "bank_account",
            component: () => import("./pages/AcimaBankAccountQuizPage.vue"),
            props: {
              id: "bank_account",
            },
          },
          {
            name: "acima-not-checking-quiz",
            path: "not_checking",
            component: () => import("./pages/AcimaBankAccountQuizPage.vue"),
            props: {
              id: "not_checking",
            },
          },
          {
            name: "acima-message-only-quiz",
            path: ":id",
            props: true,
            component: () => import("./pages/AcimaNoActionQuizPage.vue"),
          },
        ],
        meta: {
          preventBack: true,
          step: "decision",
        },
      },
    ],
  },
]
